import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@suite/shared';

@Component({
  selector: 'flx-e403',
  template: `
    <h1 translate>Access denied</h1>
    <h4 translate>You do not have access to this feature.</h4>
    <p translate>
      If you mean this to be wrong, please contact your system administrator, or
      <a href="mailto:post@noova.no">post&#64;noova.no</a> directly.
    </p>
    <footer>
      <a (click)="onRetry()" mat-raised-button class="bButton" translate>Try again?</a>
    </footer>
  `,
  styles: [
    `
      :host {
        display: block;
        position: fixed;
        background: var(--background);
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: 0 !important;
        z-index: 1000;
        place-content: center;
        place-items: center;
        .mat-mdc-raised-button ::ng-deep .mdc-button__label {
          padding-left: 2rem;
          padding-right: 2rem;
        }
        h1 {
          margin-bottom: 1rem;
        }
        h4 {
          margin-bottom: 2rem;
        }
        p {
          text-align: center;
        }
        footer {
          margin-top: 3rem;
        }
      }
    `,
  ],
  standalone: false,
})
export class E403Component {
  constructor(
    private auth: AuthService,
    private router: Router,
  ) {}

  onRetry() {
    this.router
      .navigate(['/'])
      .then((redirected) => {
        if (!redirected) this.auth.logout();
      })
      .catch(() => this.auth.logout());
  }
}
